import { Breadcrumbs } from '@/components/_common';
import { Link } from 'react-router-dom';

const AssemblyTemplateBreadcrumb = () => {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link to="/assembly-templates">Assembly Templates</Link>
      <span>Editing Template</span>
    </Breadcrumbs>
  );
};

export default AssemblyTemplateBreadcrumb;
